import { Flex } from '@awais4123/fillify-design-library';
import styled from 'styled-components';

export const AvailableMemberTabWrapper = styled(Flex)`
  height: 100%;
  overflow-y: scroll;
`;

export const AvailableMemberTabTableWrapper = styled.div``;
